import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import SearchSave, {searchSaveTrackingOrigins, searchSaveTypes} from '@adv-mt/mt-search-save'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BELL_PATH = 'images/bell-color.svg'

const BASE_CLASS = 'mt-PanelSearchSave'

export default function PanelSearchSave({adId, createdAlert, province, search, searchSaveTrackingOrigin, vehicle}) {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const APP_NAME = config.get('APP_NAME')
  const APP_NAME_COCHES = config.get('APP_NAME_COCHES')
  const isCoches = APP_NAME === APP_NAME_COCHES
  const srcBellImage = `${urlStatics}${BELL_PATH}`
  const alertTitle = i18n.t('RECEIVE_ALERTS_VEHICLE_IN_PROVINCE', {
    vehicle,
    province
  })
  const searchSaveTitle = i18n.t('SEARCH.TOOLTIP_SAVE')
  const title = isCoches ? searchSaveTitle : alertTitle

  return (
    <PanelBasic>
      <div className={BASE_CLASS}>
        <div className={`${BASE_CLASS}-info`}>
          <div className={`${BASE_CLASS}-imageWrapper`}>
            <AtomImage alt={searchSaveTitle} src={srcBellImage} height={55} width={55} />
          </div>
          <div className={`${BASE_CLASS}-text`}>
            <TitleBasic
              as={titleBasicTags.h2}
              description={i18n.t('RECEIVE_ALERTS_TO_THE_EMAIL')}
              size={titleBasicSizes.xs}
              title={title}
            />
          </div>
        </div>
        <div className={`${BASE_CLASS}-button`}>
          <SearchSave
            type={searchSaveTypes.detail}
            search={search}
            adId={adId}
            createdAlert={createdAlert}
            trackingOrigin={searchSaveTrackingOrigin}
            showTooltip={false}
          />
        </div>
      </div>
    </PanelBasic>
  )
}

export {searchSaveTrackingOrigins}

PanelSearchSave.displayName = 'PanelSearchSave'
PanelSearchSave.propTypes = {
  adId: PropTypes.string,
  createdAlert: PropTypes.object,
  province: PropTypes.string.isRequired,
  search: PropTypes.object.isRequired,
  searchSaveTrackingOrigin: PropTypes.oneOf(Object.values(searchSaveTrackingOrigins)),
  vehicle: PropTypes.string.isRequired
}
